import { notify, ToastType } from "utils/Toast";
import Resizer from "react-image-file-resizer";

async function ImageCompress(image: object,shouldCheckMinSide: boolean = true, minimumLength: number = 600) {
  let base64Image: any = await imageToBase64(image);
  let isTypeValid = checkFileType(base64Image);
  if (isTypeValid === false) {
    return false;
  }
  if (shouldCheckMinSide === true) {
    let newImage = new Image();
    newImage.src = base64Image;
    let isMinSideLengthValid: any = await onLoadImageCheckMinSideLength(
      newImage,
      base64Image,
      minimumLength
    );
  
    if (isMinSideLengthValid === false) {
      return false;
    }
  }

  let finalImageBase64: any = base64Image;
  let finalImageFile: any = image;
  if (calculateBase64Volume(finalImageBase64) > 150) {
    finalImageFile = await resizeFile(image, 90);
    finalImageBase64 = await imageToBase64(finalImageFile);
    if (calculateBase64Volume(finalImageBase64) > 150) {
      finalImageFile = await resizeFile(image, 80);
      finalImageBase64 = await imageToBase64(finalImageFile);
      if (calculateBase64Volume(finalImageBase64) > 150) {
        finalImageFile = await resizeFile(image, 70);
        finalImageBase64 = await imageToBase64(finalImageFile);
        if (calculateBase64Volume(finalImageBase64) > 150) {
          finalImageFile = await resizeFile(image, 60);
          finalImageBase64 = await imageToBase64(finalImageFile);
        }
      }
    }
  }
  let blob = base64ToBlob(finalImageBase64);
  return blob;
}

const imageToBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const base64ToBlob = (base64Image: string) => {
  const splitDataURI = base64Image.split(",");
  const byteString =
    splitDataURI[0].indexOf("base64") >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(":")[1].split(";")[0];

  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
  return new Blob([ia], { type: mimeString });
};

function onLoadImageCheckMinSideLength(
  newImage: any,
  base64Image: any,
  minimumLength: number
) {
  return new Promise(
    (resolve) =>
      (newImage.onload = function () {
        if (newImage.width < minimumLength || newImage.height < minimumLength) {
          notify(
            `The minimum length or width of the image must be at least ${minimumLength}`,
            ToastType.error
          );
          resolve(false);
        } else {
          resolve(true);
        }
      })
  );
}

const checkFileType = (base64: string) => {
  const fileFormat = base64.split(";base64")[0].replace("data:", "");
  if (fileFormat.split("/")[0] !== "image") {
    notify(
      'Only image type is valid',
      ToastType.error
    );
    return false;
  }

  return true;
};

const resizeFile = (file: any, quality: number) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1080,
      1080,
      "JPEG",
      quality,
      0,
      (uri) => {
        resolve(uri);
      },
      "file"
    );
  });

const calculateBase64Volume = (base64: string) => {
  const base64String = base64.substring(base64.indexOf(",") + 1);
  const bits = base64String.length * 6;
  const kb = bits / 8000;
  return kb;
};

export default ImageCompress;
